import { image } from '../../../../utils/data/baseUrl';
import { conturs, defaultContur, defaultStore } from '../../../../translations';

export const background =
  defaultContur === conturs.cis
    ? image(`interactiveShop/backgrounds/interactive-shop-${defaultStore}.png`)
    : image(`interactiveShop/backgrounds/interactive-shop-me.png`);
